import {Injectable} from "@angular/core";
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { XPRESS_APPLICANT, XPRESS_LOAN } from 'src/models/xpress_loan.model';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { FUNDDEPOSIT_INPUTREQUEST } from 'src/models/fund-deposit.model';
import { CommonService } from './common.service';
import { AppComponent } from "src/app/app.component";
import { ApplicantLoanComponent } from "src/app/applicant-loan/applicant-loan.component";
import { FinalPageComponent } from "src/components/final-page/final-page.component";
import { HttpClient } from "@angular/common/http";


@Injectable(
    {
        providedIn: "root"
    }
)
export class ApiService {

    authService: any ={};
    private cache = {

        productCategories: []
    }

    constructor(private httpClient: HttpClient,
         private commonService: CommonService) {

        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        if (openIdTokenParams && openIdTokenParams.access_token) {
            this.authService.accessToken = openIdTokenParams.access_token;
        }
    }

    // protected getAuthHeader(includeJsonContentType?: boolean): RequestOptions {
    //     if(!this.authService.accessToken){
    //         var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
    //         if (openIdTokenParams && openIdTokenParams.access_token) {
    //             this.authService.accessToken = openIdTokenParams.access_token;
    //         }
    //     }
    //     let headers = new Headers(
    //         // { 'Authorization': 'Bearer ' + this.authService.accessToken }
    //         );

    //     if (includeJsonContentType)
    //         headers.append("Content-Type", "application/json");

    //     headers.append("Accept", `application/json, text/plain, */*`);

    //     return new RequestOptions({ headers: headers });
    // }

    private handleError_submit(error : Response) {
        //should redirect to final page also
        ApplicantLoanComponent.forceFinalPageError = true;
        FinalPageComponent.isLoading = false;
        return Observable.throw(error.json());
    }

    private handleError(error : Response) {
        // if(error.status == 404){
        //     alert('404 error');
        //     return;
        // }
        return throwError(error);
        //throw new Error(error.json())
    }

    submitXpressApp(xpressLoan: XPRESS_LOAN, submitHistoryId:string, comboId :string = '', captchatoken? :string, baseType?: number):Observable<any>{
      var body ={
          xPRESS_LOAN: xpressLoan,
          fromSite: window.location.href,
          payCheckPerksSelected: AppComponent.paycheck_perks_selected,
          payCheckPerksRoundUp: AppComponent.paycheck_perks_round_up_selected
      }

      var opts = this.commonService.getAuthHeader(true);
      opts.headers.append('comboid', comboId);
      return this
          .httpClient
          .post(this.commonService.baseUrl + `/api/xpressLoan/submit/${submitHistoryId}?captchaToken=${captchatoken}&baseType=${baseType}` 
          , body, opts).pipe(
              catchError((err) => {
                return this.commonService.handleError(err);    //Rethrow it back to component
              })
            )
  }

  updateXpressApp(xpressLoan: XPRESS_LOAN, soResponses:any, submitHistoryId, comboId :string = ''):Observable<any>{
    var body ={
        submitXAModelJObject: {
          xPRESS_LOAN: xpressLoan,
          fromSite: window.location.href,
          payCheckPerksSelected: AppComponent.paycheck_perks_selected,
          payCheckPerksRoundUp: AppComponent.paycheck_perks_round_up_selected
        },
        soResponse:soResponses,
        submitHistoryId : submitHistoryId,
        comboId: comboId
    }

    var opts = this.commonService.getAuthHeader(true);
    opts.headers.append('comboid', comboId);
    return this.httpClient.post(this.commonService.baseUrl + `/api/xpressLoan/update` , body, opts).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
}

  fundDeposit(request, submitHistoryId? : string):Observable<any>{
      return this
          .httpClient
          .post(this.commonService.baseUrl + "/api/xpressLoan/fund-deposit?submitHistoryId="+submitHistoryId, request, this.commonService.getAuthHeaderNew(true));
  }

  
  submitDecisionLoan(selectedLoanType: LoanTypeEnum, submitHistoryId, comboId: string='' , decisionLoan):Observable<any>{
    var body ={
      cCLoanJObject: decisionLoan,
      fromSite: window.location.href,
    }
      var opts = this.commonService.getAuthHeader(true);
      opts.headers.append('comboid', comboId);

      return this
          .httpClient
          .post(this.commonService.baseUrl + `/api/decisionLoan/submit/${selectedLoanType}/${submitHistoryId}` , body,opts ).pipe(
              catchError((err) => {
                return this.commonService.handleError(err);
              })
            )
  }

  updateDecisionLoan(decisionLoan, soResponses:any, submitHistoryId, loanId ):Observable<any>{
    var body ={
      submitDecisionLoanObject: {
        cCLoanJObject: decisionLoan,
        fromSite: window.location.href,         
      },
      soResponse:soResponses,
      submitHistoryId : submitHistoryId,
      loanId: loanId
  }

      var opts = this.commonService.getAuthHeader(true);
      return this
          .httpClient
          .post(this.commonService.baseUrl + "/api/decisionLoan/update", body,opts ).pipe(
              catchError((err) => {
                return this.commonService.handleError(err);
              })
            )
  }

    checkBadMember(ssn):Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/xpressLoan/check-bad-member/"+ ssn, this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getFirstDefaultProduct():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/product/get-first-default-product/?refChannel="+ApplicantLoanComponent.refChannel, this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getCategories():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/product/get-categories/?refChannel="+ApplicantLoanComponent.refChannel, this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    //Employment endpoints

    getEmployerNames():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/employment/get-employer-names/", this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getEmploymentStatuses():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/employment/get-employment-statuses/", this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getOccupationStatuses():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/employment/get-occupation-statuses/", this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getStates():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/employment/get-states/", this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    getStaticLinks():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/staticLinks/get-static-links/", this.commonService.getAuthHeaderNew(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              );
    }

    getPayGrades():Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + "/api/employment/get-pay-grades/", this.commonService.getAuthHeader(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

   

    getCurrentStatus(appId):Observable<any>{
        return this
            .httpClient
            .get(this.commonService.baseUrl + `/api/NmaoWf/get-current-app-status/${appId}`, this.commonService.getAuthHeaderNew(true)).pipe(
                catchError((err) => {
                  return this.commonService.handleError(err);
                })
              )
    }

    

    symitarBook(appId, submitHistoryId?: string):Observable<any>{
        return this
            .httpClient
            .post(this.commonService.baseUrl + `/api/xpressLoan/symitar-book/${appId}?submitHistoryId=${submitHistoryId}`, {}, this.commonService.getAuthHeaderNew(true));
    }

    getVehiclePurposes(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/product/get-vehicle-purposes`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getAutoMakes(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/product/get-auto-makes`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getMemberReferences(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/member/get-references?channelId=`+ApplicantLoanComponent.currentChannel?.id, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getServedAreas(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/employment/get-served-areas`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      
      getQualifyingZips(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/employment/get-qualifying-zips`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

            
      getEligibilityRelationships(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/employment/get-eligibility-relationship`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      //Docu-Sign

      getDocuSignDocs(appId: string, productGroupId, productId): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/docuSign/generate-docu-sign/${appId}/${productGroupId}/${productId}`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getLoan(loanId): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/xpressLoan/get-loan/${loanId}`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getMemberNumber(loanId): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/xpressLoan/get-member-number/${loanId}`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getLoanDecision(loanId): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/xpressLoan/get-loan-decision/${loanId}`, this.commonService.getAuthHeader(true)).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getBank(routingNumber): Observable<any> {
        return this
        .httpClient
        .get(`https://www.routingnumbers.info/api/data.json?rn=${routingNumber}`).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getNmaoConfigurations(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/product/get-nmao-configurations`).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
      }

      getQualificationAssessment(): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/qualificationAssessment/get-QualificationAssessment`)
      }

      getChannelByCurrentUri(channelUri): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/channel/get-channel?channelUri=${channelUri}` ).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
      }

      getFundingSources(baseType, channelUri): Observable<any> {
          return this
          .httpClient
          .get(this.commonService.baseUrl + `/api/Funding/get-funding-sources/${baseType}/${channelUri}` ).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
      }

      getFundingSourcesNew(baseType, channelUri): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/Funding/get-funding-sources-new/${baseType}/${channelUri}` ).pipe(
          catchError((err) => {
            return this.commonService.handleError(err);    //Rethrow it back to component
          })
        )
      }

      getLoanApiLog(appId, stepId): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/loanApiLog/get-loan-api-log/${appId}/${stepId}` ).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
    }

    getLoanApiLogByApiLink(appId, apiLink): Observable<any> {
        return this
        .httpClient
        .get(this.commonService.baseUrl + `/api/loanApiLog/get-loan-api-log-by-link/${appId}/${apiLink}` ).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);    //Rethrow it back to component
            })
          )
    }

    submitNewAlloyApplication(alloyApplication, submithistoryId): Observable<any> {
      var fromSite = window.location.href
        return this
        .httpClient
        .post(this.commonService.baseUrl +`/api/alloy/new-alloy-application/${submithistoryId}?fromSite=${fromSite}`, alloyApplication, this.commonService.getAuthHeader()).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
          )
    }

    saveFundingLog(newFundingLog: any): Observable<any> {
      return this
      .httpClient
      .post(`${this.commonService.baseUrl}/api/Funding/save-log`, newFundingLog,this.commonService.getAuthHeader() ).pipe(
        catchError((err) => {
          return this.commonService.handleError(err);  
        })
      )
    }

    getProductTypeConfig(): Observable<any> {
      return this.httpClient.get('./assets/xa_tests_json/product_Type_Config.json');
    }

    fetchAndUploadDocuments(entityToken): Observable<any> {
      return this.httpClient.get(`${this.commonService.baseUrl}/api/Alloy/fetch-and-upload-documents/${entityToken}`,this.commonService.getAuthHeader()).pipe(
        catchError((err) => {
          return this.commonService.handleError(err);  
        })
      );
    }

    saveMiscEvent(payload): Observable<any> {
      return this
        .httpClient
        .post(this.commonService.baseUrl +`/api/SubmitHistoryMiscEvent/misc-event`, payload, this.commonService.getAuthHeader()).pipe(
            catchError((err) => {
              return this.commonService.handleError(err);
            })
        )
    }

    generateSubmitHistory(xpressApplicant: XPRESS_APPLICANT): Observable<any> {
      var submitHistory ={
          firstName : xpressApplicant.first_name,
          lastName : xpressApplicant.last_name,
          ssnLast4 : xpressApplicant.ssn.slice(-4),
          fromSite : window.location.href
        };
      return this.httpClient.post(`${environment.baseUrl}/api/SubmitHistory/generate-new-submit-history`, submitHistory, this.commonService.getAuthHeader())
        .pipe(
          catchError(this.commonService.handleError)
        );
  }
}